<template>
  <b-row>
    <b-col md="12">
      <b-card no-body>
        <b-card-body>
          <b-row>
            <b-col>
              <b-input-group>
                <b-form-input
                  v-model="keyword"
                  placeholder="Bin No Arama..."
                  @keydown.enter="getDataList"
                />
                <b-input-group-append>
                  <b-button
                    variant="danger"
                    @click="getDataList"
                  >
                    <FeatherIcon icon="SearchIcon" />
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-col>
            <b-col
              cols="12"
              md="auto"
            >
              <b-button
                to="bins/add"
                variant="primary"
              >
                <FeatherIcon icon="PlusIcon" />
                Oluştur
              </b-button>
            </b-col>
          </b-row>
        </b-card-body>
        <b-table
          responsive="sm"
          :fields="fields"
          :items="dataList"
          striped
        >
          <template #cell(title)="data">
            {{ data.item.title }}
          </template>
          <template #cell(control)="data">
            <b-button
              :to="'/bins/edit/' + data.item.id"
              variant="outline-primary"
              size="sm"
            >
              Güncelle
            </b-button>
          </template>
        </b-table>
        <b-card-footer>
          <b-pagination
            v-model="currentPage"
            :total-rows="dataCount"
            :per-page="perPage"
            first-number
            last-number
            prev-class="prev-item"
            next-class="next-item"
          >
            <template #prev-text>
              <feather-icon
                icon="ChevronLeftIcon"
                size="18"
              />
            </template>
            <template #next-text>
              <feather-icon
                icon="ChevronRightIcon"
                size="18"
              />
            </template>
          </b-pagination>
        </b-card-footer>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import {
  BCard, BRow, BCol, BTable, BCardFooter, BPagination, BButton, BCardBody, BFormInput, BInputGroup, BInputGroupAppend,
} from 'bootstrap-vue'

export default {
  name: 'BinsIndex',
  components: {
    BCard,
    BTable,
    BRow,
    BCol,
    BCardFooter,
    BPagination,
    BButton,
    BCardBody,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
  },
  data() {
    return {
      keyword: '',
      currentPage: 1,
      perPage: 25,
      fields: [
        {
          key: 'bin_no',
          label: 'BIN NO',
          thClass: 'text-nowrap width-100',
          tdClass: 'text-nowrap width-100',
        },
        {
          key: 'bank',
          label: 'Banka',
        },
        {
          key: 'card_organization',
          label: 'ÖDEME AĞI',
          thClass: 'text-nowrap width-100',
          tdClass: 'text-nowrap width-100',
        },
        {
          key: 'card_type',
          label: 'KART TİPİ',
          thClass: 'text-nowrap width-100',
          tdClass: 'text-nowrap width-100',
        },
        {
          key: 'control',
          label: '',
          thClass: 'text-right width-100',
          tdClass: 'text-right width-100',
        },
      ],
      dataQuery: {
        select: [
          'bins.id AS id',
          'bins.bin_no AS bin_no',
          'card_organization.title AS card_organization',
          'card_type.title AS card_type',
          'banks.title AS bank',
        ],
        limit: 50,
        start: 0,
      },
    }
  },
  computed: {
    dataList() {
      return this.$store.getters['binsDefines/dataList']
    },
    dataCount() {
      return this.$store.getters['binsDefines/dataCounts']
    },
  },
  watch: {
    currentPage(val) {
      const page = (val - 1) * 50
      this.pagination(page)
    },
  },
  created() {
    this.getDataList()
  },
  methods: {
    pagination(page) {
      this.dataQuery.start = page
      if (this.dataQuery.start === page) {
        this.getDataList()
      }
    },
    getDataList() {
      if (this.keyword.length > 2) {
        this.dataQuery.or_like = {
          'bins.bin_no': this.keyword,
        }
      } else {
        delete this.dataQuery.or_like
      }
      this.$store.dispatch('binsDefines/getDataList', this.dataQuery)
    },
  },
}
</script>
